var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-mit-page"},[_vm._m(0),_c('div',{staticClass:"return-tip"},[_vm._v(_vm._s(_vm.$t('register.LAB_MITID_CLIENT_RETURN_TIP')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watermark-wrapper"},[_c('img',{staticClass:"watermark",attrs:{"src":"/static/img/mit/KKPOKER_Brand_Logo.png","alt":""}})])
}]

export { render, staticRenderFns }